import { render } from "./TooltipUserAvatarAndUsername.vue?vue&type=template&id=0e4eca96&scoped=true"
import script from "./TooltipUserAvatarAndUsername.vue?vue&type=script&lang=js"
export * from "./TooltipUserAvatarAndUsername.vue?vue&type=script&lang=js"

import "./TooltipUserAvatarAndUsername.vue?vue&type=style&index=0&id=0e4eca96&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0e4eca96"]])

export default __exports__